import { Component, OnInit } from '@angular/core';

import { CsrfService } from './core/services/csrf/csrf.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'fruive-admin';

  constructor(private csrfService: CsrfService) {}

  ngOnInit(): void {
    this.csrfService.bootstrap().subscribe();
  }
}
